import React, { useRef, useEffect, useState } from 'react';
import style from "./WhiteBoard.module.css";

export const Whiteboard = () => {
  const canvasRef = useRef(null);
  const canvasWrapRef = useRef(null);
  const [drawing, setDrawing] = useState(false);
  const [color, setColor] = useState('#000000'); // Default color
  const [brushSize, setBrushSize] = useState(5); // Default brush size
  const [eraserMode, setEraserMode] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const wrap = canvasWrapRef.current;
    if (!canvas || !wrap) return;

    const resizeCanvas = () => {
      const width = Math.max(320, Math.floor(wrap.clientWidth));
      const height = Math.max(240, Math.floor(wrap.clientHeight));
      if (canvas.width === width && canvas.height === height) return;

      const previous = document.createElement('canvas');
      previous.width = canvas.width;
      previous.height = canvas.height;
      const prevCtx = previous.getContext('2d');
      prevCtx.drawImage(canvas, 0, 0);

      canvas.width = width;
      canvas.height = height;
      const context = canvas.getContext('2d');
      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, width, height);
      if (previous.width && previous.height) {
        context.drawImage(previous, 0, 0, previous.width, previous.height, 0, 0, width, height);
      }
    };

    resizeCanvas();
    const observer = new ResizeObserver(resizeCanvas);
    observer.observe(wrap);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const context = canvas.getContext('2d');
    context.strokeStyle = color; // Set initial drawing color
    context.lineWidth = brushSize; // Set initial brush size
    context.lineCap = 'round';
    context.lineJoin = 'round';

    const handleMouseDown = (event) => {
      setDrawing(true);
      const bounds = canvas.getBoundingClientRect();
      const x = event.clientX - bounds.left;
      const y = event.clientY - bounds.top;
      context.beginPath();
      context.moveTo(x, y);
    };

    const handleMouseMove = (event) => {
      if (!drawing) return;
      const bounds = canvas.getBoundingClientRect();
      const x = event.clientX - bounds.left;
      const y = event.clientY - bounds.top;
      if (eraserMode) {
        context.clearRect(x - brushSize / 2, y - brushSize / 2, brushSize, brushSize);
      } else {
        context.lineTo(x, y);
        context.stroke();
      }
    };

    const handleMouseUp = () => {
      setDrawing(false);
    };

    canvas.addEventListener('mousedown', handleMouseDown);
    canvas.addEventListener('mousemove', handleMouseMove);
    canvas.addEventListener('mouseup', handleMouseUp);

    return () => {
      canvas.removeEventListener('mousedown', handleMouseDown);
      canvas.removeEventListener('mousemove', handleMouseMove);
      canvas.removeEventListener('mouseup', handleMouseUp);
    };
  }, [drawing, eraserMode, brushSize, color]);

  const handleColorChange = (event) => {
    setColor(event.target.value);
    if (eraserMode) setEraserMode(false);
  };

  const handleBrushSizeChange = (event) => {
    setBrushSize(parseInt(event.target.value));
  };

  const toggleEraserMode = () => {
    setEraserMode(!eraserMode);
  };

  return (
    <div className={style.WhiteboardRoot}>
      <div className={style.Toolbar}>
        <input type="color" value={color} onChange={handleColorChange} />
        <input type="range" min="1" max="50" value={brushSize} onChange={handleBrushSizeChange} />
        <button className={style.EraseButton} onClick={toggleEraserMode}>{eraserMode ? 'Disable Eraser' : 'Enable Eraser'}</button>
      </div>
      <div ref={canvasWrapRef} className={style.CanvasWrap}>
        <canvas ref={canvasRef} className={style.Canvas} />
      </div>

    </div>
  );
};

export default Whiteboard;
